import { createFileRoute } from '@tanstack/react-router'
import { AdminRileyFunctions } from '../features/admin'
import { adminRouteState } from '../features/admin/route-state'

export const Route = createFileRoute('/admin/riley-functions')({
  ...adminRouteState,
  component: AdminRileyFunctions,
})
